import PropTypes from "prop-types";
import React, { Fragment } from "react";

/**
 * Renders AB test experiment based on the `currentVersion` and `targetVersion` if AB test is `running`.
 * Falls back to the provided `fallback` node if the AB test is not `running` or the version does not match.
 */
export const AbTest = ({
  children,
  currentVersion,
  fallback,
  running,
  targetVersion,
}) => {
  const childNode =
    typeof children === "function"
      ? children({ currentVersion, running })
      : children;

  const matchesTargetVersion = Array.isArray(targetVersion)
    ? targetVersion.includes(currentVersion)
    : currentVersion === targetVersion;

  return (
    <Fragment>
      {running && matchesTargetVersion ? childNode : fallback}
    </Fragment>
  );
};

AbTest.propTypes = {
  /**
   * Node to render for this AB test (if enabled and version matches)
   * If a function is provided, it will be called with an object containing `currentVersion` and `running` properties
   */
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
  /**
   * Currently running AB test version
   */
  currentVersion: PropTypes.string.isRequired,
  /**
   * Optional node to render if AB test is not enabled or version does not match
   */
  fallback: PropTypes.node,
  /**
   * Whether an AB test is running
   */
  running: PropTypes.bool.isRequired,
  /**
   * Target AB test version(s) to match
   */
  targetVersion: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]).isRequired,
};
